import {
  MobileMenuCheckboxItem,
  MobileMenuContent,
} from '@/ux-common/components/mobile-menu/mobile-menu';
import {
  MobileMenuInput,
  MobileMenuInputTrigger,
} from '@/ux-common/components/mobile-menu-input/mobile-menu-input';
import { withTooltip } from '@/ux-common/components/tooltip/with-tooltip';

import { EVENT_DAYS } from './defrost-schedule.constant';
import {
  type DefrostScheduleEventDayFieldProps,
  useDefrostEventDays,
} from './use-defrost-event-days';

const MobileMenuInputTriggerWithTooltip = withTooltip(MobileMenuInputTrigger);

/**
 * Phone twin of DefrostScheduleEventDayDropdown: the same field, opening a bottom
 * sheet of checkbox rows. Ticking a day keeps the sheet open.
 */
export const DefrostScheduleEventDayMobileMenu = ({
  disabled,
  error,
  onChange,
  values,
}: DefrostScheduleEventDayFieldProps) => {
  const { handleOpenChange, isOpen, selectedDays, toggleDay } = useDefrostEventDays({
    disabled,
    onChange,
    values,
  });

  return (
    <MobileMenuInput
      data-component="DefrostScheduleEventDayMobileMenu"
      onOpenChange={handleOpenChange}
      open={isOpen}
      state={error ? 'error' : undefined}
    >
      {/* Wrapped unconditionally — a conditional wrapper would remount the trigger
          the moment the validation message clears. */}
      <MobileMenuInputTriggerWithTooltip
        contentClassName="text-ckds-base-critical"
        disabled={disabled}
        placeholder="Select Day(s)"
        tooltipArrow
        tooltipContent={error ? error : undefined}
      >
        {selectedDays}
      </MobileMenuInputTriggerWithTooltip>
      <MobileMenuContent title="Event days">
        {EVENT_DAYS.map((day) => (
          <MobileMenuCheckboxItem
            checked={values?.includes(day.value) ?? false}
            key={day.value}
            onCheckedChange={(checked) => toggleDay(checked, day.value)}
          >
            {day.label}
          </MobileMenuCheckboxItem>
        ))}
      </MobileMenuContent>
    </MobileMenuInput>
  );
};
